// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectRainwaterPipeQueryResult, selectRainwaterPipesPageLoading, selectRainwaterPipesShowInitWaitingMessage} from '../_selectors/rainwater-pipe.selectors';

export class RainwaterPipesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectRainwaterPipesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectRainwaterPipesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectRainwaterPipeQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
